// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toast__container-e97bd4 {
  position: fixed;
  inset-inline-start: 16px;
  bottom: 16px;
  z-index: 1000;
  width: calc(var(--sidebar-width) - 88px);
  background-color: var(--base-100);
  box-sizing: border-box;
  padding: 12px 16px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: var(--base-0);
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  transition: opacity 300ms ease-out;
}

.Toast__style-5-ae9bbd {
  text-align: center;
  justify-content: center;
}

.Toast__style-1-cf623d {
  text-align: start;
  justify-content: flex-start;
}

.Toast__style-4-b5e55e {
  text-align: start;
  justify-content: flex-start;
  color: var(--addition-50);
  background-color: var(--danger-40);
  font: var(--font-body-3);
}

.Toast__container-global-d5c474 {
  position: fixed;
  inset-inline-start: 16px;
  bottom: 16px;
}

.Toast__container-target-e92842 {
  position: absolute;
  inset-inline-start: 50%;
  transform: translateX(-50%);
  bottom: 8px;
}

.Toast__toast-exit-e2c567 {
  opacity: 0;
}

.Toast__toast-exit-active-ccfff4 {
  opacity: 0;
}

.Toast__toast-enter-d4ec55 {
  opacity: 1;
}

.Toast__toast-enter-active-c5a12b {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/popups/src/components/Toast/Toast.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EAEA,wCAAA;EACA,iCAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,wBAAA;EACA,0CAAA;EAEA,kCAAA;AAHF;;AAMA;EACE,kBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kCAAA;EACA,wBAAA;AAHF;;AAMA;EACE,eAAA;EACA,wBAAA;EACA,YAAA;AAHF;;AAMA;EACE,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,UAAA;AAHF","sourcesContent":[".container {\n  position: fixed;\n  inset-inline-start: 16px;\n  bottom: 16px;\n  z-index: 1000;\n\n  width: calc(var(--sidebar-width) - 88px);\n  background-color: var(--base-100);\n  box-sizing: border-box;\n  padding: 12px 16px;\n  border-radius: 12px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  color: var(--base-0);\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n\n  transition: opacity 300ms ease-out;\n}\n\n.style-5 {\n  text-align: center;\n  justify-content: center;\n}\n\n.style-1 {\n  text-align: start;\n  justify-content: flex-start;\n}\n\n.style-4 {\n  text-align: start;\n  justify-content: flex-start;\n  color: var(--addition-50);\n  background-color: var(--danger-40);\n  font: var(--font-body-3);\n}\n\n.container-global {\n  position: fixed;\n  inset-inline-start: 16px;\n  bottom: 16px;\n}\n\n.container-target {\n  position: absolute;\n  inset-inline-start: 50%;\n  transform: translateX(-50%);\n  bottom: 8px;\n}\n\n.toast-exit {\n  opacity: 0;\n}\n\n.toast-exit-active {\n  opacity: 0;\n}\n\n.toast-enter {\n  opacity: 1;\n}\n\n.toast-enter-active {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Toast__container-e97bd4`,
	"style-5": `Toast__style-5-ae9bbd`,
	"style5": `Toast__style-5-ae9bbd`,
	"style-1": `Toast__style-1-cf623d`,
	"style1": `Toast__style-1-cf623d`,
	"style-4": `Toast__style-4-b5e55e`,
	"style4": `Toast__style-4-b5e55e`,
	"container-global": `Toast__container-global-d5c474`,
	"containerGlobal": `Toast__container-global-d5c474`,
	"container-target": `Toast__container-target-e92842`,
	"containerTarget": `Toast__container-target-e92842`,
	"toast-exit": `Toast__toast-exit-e2c567`,
	"toastExit": `Toast__toast-exit-e2c567`,
	"toast-exit-active": `Toast__toast-exit-active-ccfff4`,
	"toastExitActive": `Toast__toast-exit-active-ccfff4`,
	"toast-enter": `Toast__toast-enter-d4ec55`,
	"toastEnter": `Toast__toast-enter-d4ec55`,
	"toast-enter-active": `Toast__toast-enter-active-c5a12b`,
	"toastEnterActive": `Toast__toast-enter-active-c5a12b`
};
module.exports = ___CSS_LOADER_EXPORT___;
